import {
    setCookie,
    initializeMap,
    initMenuTrigger,
    initOpenInNewTab,
    aosConfig,
    addScollClass,
    addParalax,
    addFancyboxFixForGallery,
    addCloseCookies,
    initForm,
    googleMapInit,
    initLoadNews
} from './functions';



//import gsap from "gsap";


const mainApp = () => {



    // init menu trigger
    initMenuTrigger();

    // init open in new tab
    initOpenInNewTab();

    // init AOS animation config
    aosConfig();

    // add scroll class to body  
    addScollClass('0px');

    // add paralax to element
    addParalax('.paralax');



    //fix gallery id for slideshow
    addFancyboxFixForGallery('.blocks-gallery-grid');

    // add close function to cookies
    addCloseCookies();



    //start - contact form
    initForm();

    googleMapInit();


    initLoadNews();



}

document.addEventListener("DOMContentLoaded", mainApp, false);




const animSlogan = (slogan, num) => {
    let target = document.querySelector('.subpageHeader__slider');
    target.innerHTML = '';
    target.classList.remove('border', 'hide');
    window.setTimeout(() => {


        new Promise((resolve, reject) => {
            let text = slogan[num];
            let textShow = '';
            let counter = 0;
            const time = window.setInterval(() => {
                textShow += text[counter];
                target.innerHTML = textShow;
                if (textShow.length == text.length) {
                    window.clearInterval(time);
                    resolve();
                }
                counter++;
            }, 80);

        }).then(() => {
            target.classList.add('border');
            return new Promise((resolve, reject) => window.setTimeout(() => {
                resolve();
            }, 2500));
        }).then(() => {
            target.classList.add('hide');
            target.classList.remove('border');
            window.setTimeout(() => {
                animSlogan(slogan, slogan.length - 1 == num ? 0 : ++num);
            }, 500);
        });
    }, 2000);

}

(function ($) {
    const mainAppWithJquery = () => {

        let sliderContent = document.querySelector('.subpageHeader__slider');
        if (sliderContent) {

            let slider = sliderContent.dataset.slider.split(';').map((item) => item.split(''));
            animSlogan(slider, 0);
        }



        if (!!window.IntersectionObserver) {
            let topHeaderObserver = new IntersectionObserver(entries => {
                if (entries[0].intersectionRatio > 0) {


                    $('.companyNumbers__title > span').each(function () {
                        var counter = $(this).text();
                        $(this).text(0);
                        var $this = $(this);
                        window.setTimeout(function () {
                            $this.prop('Counter', 0).animate({
                                Counter: counter
                            }, {
                                duration: 2000,
                                easing: 'swing',
                                step: function (now) {
                                    $this.text(Math.ceil(now));
                                    //counter = Math.ceil(now);
                                }
                            });
                        }, 300);
                    });
                    topHeaderObserver.unobserve(entries[0].target);
                }
            });
            if (document.querySelector('.companyNumbers')) {
                topHeaderObserver.observe(document.querySelector('.companyNumbers'));
            }
        }



        $('.subpageHeader__mouse').click(function () {
            $('body,html').animate({ 'scrollTop': ($('.subpageHeader').outerHeight() - 50) + 'px' }, 500);
        });


        if ($('.wp-block-gallery').length > 0) {
            $('.wp-block-gallery').each(function (i) {
                let newGallery = $('<div class="newGallery"><h3 class="newGallery__header">' +
                    $(this).find('.blocks-gallery-caption').text() +
                    '</h3><div  class="newGallery__slider slickSliderUi"></div></div>');
                let tempItem = '';
                $(this).find('.blocks-gallery-item figure, .wp-block-image').each(function (index) {
                    let newItem = $('<div class="newGallery__slide">' + $(this).html() + '</div>');
                    newItem.append(tempItem);
                    newGallery.find('.newGallery__slider').append(newItem);
                    tempItem = '';

                });
                $(this).before(newGallery);
                var idGal = 'gal' + (Math.floor(Math.random() * 100));
                newGallery.find('a').each(function () {
                    $(this).attr('data-fancybox', idGal);
                    $(this).attr('data-caption', $(this).next('figcaption').text());
                    $(this).find('img').removeAttr('loading');
                });
                $(this).remove();

            });



        }

        $('.newGallery__slider').slick({
            infinite: true,
            arrows: true,
            dots: false,
            autoplay: true,
            speed: 500,
            autoplaySpeed: 10000,
            slidesToShow: 3,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 769,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                    }
                }
            ]
        });

        $('.indexC3__logos').slick({
            infinite: true,
            arrows: false,
            dots: false,
            autoplay: true,
            speed: 3000,
            autoplaySpeed: 0,
            cssEase: 'linear',
            //slidesToShow: 3,
            // slidesToScroll: 1,
            // centerMode: true,
            variableWidth: true,
            pauseOnFocus: false,
            pauseOnHover: false,
            pauseOnDotsHover: false
        });





        //rotator and sliders
        if ($('.rotatorTop').length > 0) {
            $('.rotatorTop').slick({
                infinite: true,
                arrows: true,
                dots: true,
                autoplay: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 500,
                autoplaySpeed: 5000,
                fade: true,
                cssEase: 'linear'
            });
            var currentRotSlide = 0;
            $('.rotatorTop').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
                currentRotSlide = currentSlide;
                $('.rotatorTop .rotator__slide:nth-child(' + (currentSlide + 1) + ')').addClass('slick-out');
            });
            $('.rotatorTop').on('afterChange', function (event, slick, currentSlide, nextSlide) {
                $('.rotatorTop .rotator__slide:nth-child(' + (currentRotSlide + 1) + ')').removeClass('slick-out');
            });
        }

        if ($('.rotatorText').length > 0) {
            $('.rotatorText').slick({
                infinite: true,
                arrows: true,
                dots: true,
                autoplay: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 500,
                autoplaySpeed: 10000,
                fade: true,
                cssEase: 'linear'
            });
            var currentRotSlideText = 0;
            $('.rotatorText').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
                currentRotSlideText = currentSlide;
                $('.rotatorText .rotator__slide:nth-child(' + (currentSlide + 1) + ')').addClass('slick-out');
            });
            $('.rotatorText').on('afterChange', function (event, slick, currentSlide, nextSlide) {
                $('.rotatorText .rotator__slide:nth-child(' + (currentRotSlideText + 1) + ')').removeClass('slick-out');
            });
        }
        if ($('.rotatorGallery').length > 0) {
            $('.rotatorGallery').slick({
                infinite: true,
                arrows: true,
                dots: false,
                autoplay: true,
                speed: 500,
                autoplaySpeed: 10000,
                variableWidth: true,
                centerMode: true
            });
            $('.rotatorGallery .slick-list').attr('id', 'gallery0');
        }



        //fancybox
        $(".blocks-gallery-item a, .fancybox, .wp-block-image a").fancybox({
            'loop': true,
            'margin': [44, 0],
            'gutter': 50,
            'keyboard': true,
            'arrows': true,
            'infobar': false,
            'toolbar': true,
            'buttons': ["slideShow", "fullScreen", "close"],
            'idleTime': 4,
            'protect': false,
            'modal': false,
            'animationEffect': "fade",
            'animationDuration': 600,
            'transitionEffect': "fade",
            'transitionDuration': 800,
        });



    };
    document.addEventListener("DOMContentLoaded", mainAppWithJquery, false);

})(jQuery);



/*!
* jquery.counterup.js 1.0
*
* Copyright 2013, Benjamin Intal http://gambit.ph @bfintal
* Released under the GPL v2 License
*
* Date: Nov 26, 2013
*/(function (e) { "use strict"; e.fn.counterUp = function (t) { var n = e.extend({ time: 400, delay: 10 }, t); return this.each(function () { var t = e(this), r = n, i = function () { var e = [], n = r.time / r.delay, i = t.text(), s = /[0-9]+,[0-9]+/.test(i); i = i.replace(/,/g, ""); var o = /^[0-9]+$/.test(i), u = /^[0-9]+\.[0-9]+$/.test(i), a = u ? (i.split(".")[1] || []).length : 0; for (var f = n; f >= 1; f--) { var l = parseInt(i / n * f); u && (l = parseFloat(i / n * f).toFixed(a)); if (s) while (/(\d+)(\d{3})/.test(l.toString())) l = l.toString().replace(/(\d+)(\d{3})/, "$1,$2"); e.unshift(l) } t.data("counterup-nums", e); t.text("0"); var c = function () { t.text(t.data("counterup-nums").shift()); if (t.data("counterup-nums").length) setTimeout(t.data("counterup-func"), r.delay); else { delete t.data("counterup-nums"); t.data("counterup-nums", null); t.data("counterup-func", null) } }; t.data("counterup-func", c); setTimeout(t.data("counterup-func"), r.delay) }; t.waypoint(i, { offset: "100%", triggerOnce: !0 }) }) } })(jQuery);